import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function NotFound() {
  return (
    <section className="border-b border-bone-300" data-testid="notfound-page">
      <div className="container-x py-32 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <div className="overline">/ 404</div>
          <h1 className="mt-6 font-display font-black text-[clamp(3rem,8vw,7rem)] tracking-tighter leading-[0.9] text-ink-olive">
            This page
            <br />
            <span className="font-serif italic font-light">wandered off.</span>
          </h1>
          <p className="mt-6 text-ink-soft max-w-lg">
            Let’s get you back to something useful.
          </p>
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="btn-primary mt-8"
          >
            Back home <ArrowUpRight size={18} />
          </Link>
        </div>
        <div className="lg:col-span-5">
          <div className="aspect-square border border-bone-300 grid-lines" />
        </div>
      </div>
    </section>
  );
}
